import script from "./StockAlertBox.vue?vue&type=script&setup=true&lang=js"
export * from "./StockAlertBox.vue?vue&type=script&setup=true&lang=js"

import "./StockAlertBox.vue?vue&type=style&index=0&id=4f5bb0ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f5bb0ea"]])

export default __exports__